<template>
    <v-app>
        <v-card class="elevation-12" v-if="codeSent === false">
            <v-toolbar
                    color="primary"
                    dark
                    flat
            >
                <v-toolbar-title>Forgot Password</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-text-field
                        label="Username"
                        name="username"
                        prepend-icon="mdi-account"
                        type="text"
                        v-model='form.username'
                        @keydown.enter="submitUsername"
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="submitUsername">Submit</v-btn>
            </v-card-actions>
        </v-card>

        <v-form ref="codeVerificationForm">
            <v-card class="elevation-12" v-if="codeSent === true && passwordChanged === false">
                <v-toolbar
                        color="primary"
                        dark
                        flat
                >
                    <v-toolbar-title>Verification Code</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <p>A verification code has been sent to your email address.</p>
                    <p>Please check your inbox (<strong>or spam folder</strong>) for the code and enter it below along with your new password: </p>
                    <v-text-field
                            label="Verification code"
                            name="code"
                            prepend-icon="mdi-shield-key"
                            type="text"
                            v-model='form.code'
                            default
                            :rules="isFilledRule"
                    ></v-text-field>
                    <v-text-field
                            label="New Password"
                            name="newPassword"
                            prepend-icon="mdi-form-textbox-password"
                            type="password"
                            :rules="isValidPassword"
                            v-model='form.newPassword'
                            @keydown.enter="updatePassword"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-on:click="updatePassword">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <v-card class="elevation-12" v-if="codeSent === true && passwordChanged === true">
            <v-toolbar
                    color="primary"
                    dark
                    flat
            >
                <v-toolbar-title>Password Changed</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <p>Congratulations! Your password has been changed. </p>
                <p>You can now login with the new password.</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="retryLogin">Login</v-btn>
            </v-card-actions>
        </v-card>
    </v-app>
</template>

<script>
    import { Auth } from 'aws-amplify';
    export default {
        name: "ForgotPassword",
        data() {
            return {
                form: {
                    username: '',
                    code: '',
                    newPassword: ''
                },
                formState: 'forgotPassword',
                codeSent: false,
                passwordChanged: false,
                isFilledRule: [
                    v => !!v || 'This field is required'
                ],
                isValidPassword: [
                    value => (value || '').length >= 8 || 'Password must be at least 8 characters long.'
                ]
            }
        },
        updated() {
            this.$refs.form.reset()
        },
        methods: {
            async submitUsername() {
                const { username } = this.form;
                await Auth.forgotPassword(username)
                    .then(() => {
                        this.codeSent = true;
                    })
                    .catch(err => console.log(err))
            },
            async updatePassword() {
                const { username, code, newPassword } = this.form;
                await Auth.forgotPasswordSubmit(username, code, newPassword)
                    .then(() => {
                        this.passwordChanged = true;
                    })
                    .catch(err => console.log(err))
            },
            retryLogin() {
                this.formState = 'signIn';
                this.$emit('changeState', this.formState);
            }
        }
    }
</script>